import React, { PropsWithChildren } from 'react'

import { StyledLayout, StyledLayoutContent } from './styles'
import Side from './components/Side'

type Props = PropsWithChildren<React.ReactNode>

export default function Dashboard({ children }: Props): JSX.Element {
  return (
    <StyledLayout>
      <Side />
      <StyledLayoutContent>{children}</StyledLayoutContent>
    </StyledLayout>
  )
}
